module.exports = __webpack_public_path__ + "img/cat5.c11e4844.png";